export enum InsuranceRelationshipId {
  Undefined = 0,
  Self = 16,
  Spouse = 17,
  Child = 18,
  Other = 19
}
